import React from 'react';
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <MDBFooter bgColor='light' className='text-center text-lg-start text-muted'>    
        <section style={{ paddingTop: '12px' }}>
        <MDBContainer className='text-center text-md-start mt-5'>
          <MDBRow className='mt-3'>
            <MDBCol md='3' lg='4' xl='3' className='mx-auto mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>
                <MDBIcon color='secondary' icon='gem' className='me-3' />
                {t('footer.company.title')}
              </h6>
              <p>
                {t('footer.company.description')}
              </p>
            </MDBCol>

            <MDBCol md='2' lg='2' xl='2' className='mx-auto mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>{t('footer.services.title')}</h6>
              <p>
                <Link to="/" className='text-reset'>
                  {t('footer.services.software')}
                </Link>
              </p>
              <p>
                <Link to="/" className='text-reset'>
                  {t('footer.services.web')}
                </Link>
              </p>
              <p>
                <Link to="/" className='text-reset'>
                  {t('footer.services.security')}
                </Link>
              </p>
              <p>
                <Link to="/" className='text-reset'>
                  {t('footer.services.cloud')}
                </Link>
              </p>
            </MDBCol>

            <MDBCol md='3' lg='2' xl='2' className='mx-auto mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>{t('footer.links.title')}</h6>
              <p>
                <Link to="/" className='text-reset'>
                  {t('footer.links.services')}
                </Link>
              </p>
              <p>
                <Link to="/contact" className='text-reset'>
                  {t('footer.links.contact')}
                </Link>
              </p>
            </MDBCol>

            <MDBCol md='4' lg='3' xl='3' className='mx-auto mb-md-0 mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>{t('footer.contact.title')}</h6>
              <p>
                <MDBIcon color='secondary' icon='home' className='me-2' />
                {t('footer.contact.address')}
              </p>
              <p>
                <MDBIcon color='secondary' icon='envelope' className='me-3' />
                {t('footer.contact.email')}
              </p>
              <p>
                <MDBIcon color='secondary' icon='phone' className='me-3' />
                {t('footer.contact.phone')}
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div className='text-center p-4' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
        {t('footer.copyright')}{' '}
        <a className='text-reset fw-bold' href='https://executiva.gr/'>
          {t('footer.company.link')}
        </a>
      </div>
    </MDBFooter>
  );
}